export { default as NSpace, spaceProps } from './src/Space';
